import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Snackbar, { SnackbarCloseReason } from "@mui/material/Snackbar";
import { Box } from "@mui/material";
import { RootStateType } from "@Interfaces";
import { AuthActions } from "@Store";
import { actions as NotificationActions } from "@Store/Reducers/notifications";

export const CustomizedSnackbars = () => {
    const dispatch = useDispatch<any>();
    const [displayedSnackbar, setDisplayedSnackbar] = useState({
        message: "",
        type: "",
    });
    const snackbarOpen = useSelector(
        (state: RootStateType) => state.auth.snackbarOpen
    );
    const snackbarMessage = useSelector(
        (state: RootStateType) => state.auth.snackbarMessage
    );
    const snackbarType = useSelector(
        (state: RootStateType) => state.auth.snackbarType
    );

    const notificationOpen = useSelector(
        (state: RootStateType) => state.notifications.snackbarOpen
    );
    const notificationMessage = useSelector(
        (state: RootStateType) => state.notifications.snackbarMessage
    );
    const notificationTypeChannel = useSelector(
        (state: RootStateType) => state.notifications.snackbarType
    );
    const isNotificationActive = !!notificationOpen;
    const activeMessage = isNotificationActive
        ? notificationMessage
        : snackbarMessage;
    const activeType = isNotificationActive
        ? notificationTypeChannel
        : snackbarType;
    const isSnackbarOpen = snackbarOpen || notificationOpen;
    const displayedMessage = isSnackbarOpen
        ? activeMessage
        : displayedSnackbar.message;
    const displayedType = isSnackbarOpen ? activeType : displayedSnackbar.type;
    const isReward = displayedType === "reward";

    useEffect(() => {
        if (!isSnackbarOpen) {
            return;
        }

        setDisplayedSnackbar({
            message: activeMessage || "",
            type: activeType || "",
        });
    }, [activeMessage, activeType, isSnackbarOpen]);

    const handleClose = (
        event: Event | React.SyntheticEvent<any, Event>,
        reason: SnackbarCloseReason
    ) => {
        if (displayedType === "reward") {
            return;
        }
        if (reason === "clickaway") {
            return;
        }
        dispatch(AuthActions.resetErrors());
        dispatch(NotificationActions.resetNotification());
    };

    const contentSx = isReward
        ? {
              backgroundColor: "#673ab7",
              color: "#ffffff",
              fontWeight: 600,
          }
        : displayedType === "error"
        ? {
              backgroundColor: "#FB446C",
          }
        : displayedType === "info"
        ? {
              backgroundColor: "#0288d1",
          }
        : {
              backgroundColor: "#4caf50",
          };

    return (
        <Box
            sx={{
                width: "100%",
                "& > * + *": {
                    mt: 2,
                },
            }}
        >
            <Snackbar
                ContentProps={{
                    "aria-describedby": "message-id",
                    sx: contentSx,
                }}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                open={isSnackbarOpen}
                autoHideDuration={isReward ? null : 5000}
                onClose={handleClose}
                message={
                    <span>
                        <div>{displayedMessage}</div>
                    </span>
                }
            />
        </Box>
    );
};
